import { HTTP } from '@/utils/http'
import store from '@/store'
import Router from "@/router";
const ACCESS_TOKEN_KEY = 'accessToken';

export default function interceptor () {


    // request INTERCEPTOR
    // HTTP.interceptors.request.use(config => config);
    // HTTP.interceptors.request.use(request => {
    //     if (localStorage.getItem(ACCESS_TOKEN_KEY)){
    //         request.headers.Authorization= 'Bearer ' + localStorage.getItem(ACCESS_TOKEN_KEY);
    //     }
    //     return request;
    // });

    // // response INTERCEPTOR
    // HTTP.interceptors.response.use(response => {
    //     // all is good
    //     return Promise.resolve(response)
    // }, err => {
    //
    //
    //
    //
    //
    //     return Promise.reject(err)
    // });
}
